module.exports = __webpack_public_path__ + "img/company.05c1577a.png";